import React from 'react';
import {
  GATE_DRAG_OPTIONS, GATE_TYPES,
  vaultRoleKey
} from './helper';
import RoleAccessSettings from './role_access_settings';
import ConfidentialityAgreementForm from './confidentiality_agreement_form';
import PropTypes from 'prop-types';

function VaultGate({
  allowDigitalSignPdfCas, allowMultipleCasPerRole, caSettings, gates, role, vault, onCaFileUpload, onGatesChange,
  onSimpleCaSettingsChange
}) {
  const keyForRole = vaultRoleKey(vault.id, role.type);
  const gatesForRole = gates[keyForRole];
  const showCa = gatesForRole[GATE_TYPES.IN_PROGRESS]
    .some(gate => gate.gateType === GATE_DRAG_OPTIONS.SIGN_CA);
  const simpleFieldChange = (field, newValue) => {
    onSimpleCaSettingsChange(field, newValue, keyForRole);
  };
  const caTypeChange = (field, newValue) => {
    if (allowMultipleCasPerRole) {
      // Ensure at least one CA type is selected
      const currentCaSettings = caSettings[keyForRole];
      const atLeastOneSelected = ['caTypeStandard', 'caTypeCustomText', 'caTypeCustomPdf', 'caTypeCustomWord']
        .some(caField => (caField === field ? newValue : currentCaSettings[caField]));
      if (!atLeastOneSelected && !newValue) {
        // Prevent unchecking the last selected CA type
        onSimpleCaSettingsChange(field, true, keyForRole);
      } else {
        onSimpleCaSettingsChange(field, newValue, keyForRole);
      }
    } else {
      // Ensure exactly one CA type is selected
      ['caTypeStandard', 'caTypeCustomText', 'caTypeCustomPdf', 'caTypeCustomWord'].forEach((field) => {
        onSimpleCaSettingsChange(field, false, keyForRole);
      });
      onSimpleCaSettingsChange(field, true, keyForRole);
    }
  };
  const caFileUploaded = uploadData => onCaFileUpload(uploadData, keyForRole);

  return (
    <div className="panel panel-default soft-panel p-4 mt-5 d-flex flex-column gap-4">
      <RoleAccessSettings
        caOptions={vault.caOptions}
        gates={gatesForRole}
        role={role}
        vaultId={vault.id}
        onGatesChange={onGatesChange}
      />
      <ConfidentialityAgreementForm
        allowDigitalSignPdfCas={allowDigitalSignPdfCas}
        allowMultipleCasPerRole={allowMultipleCasPerRole}
        caData={caSettings[keyForRole]}
        caOptions={vault.caOptions}
        caUrl={`/vaults/${vault.id}/ca/${role.type}`}
        roleLabel={role.label}
        show={showCa}
        standardText={role.type === 'broker' ? vault.standardBrokerCa : vault.standardOwnerCa}
        onCaTypeChange={caTypeChange}
        onCaUpload={caFileUploaded}
        onSimpleFieldChange={simpleFieldChange}
      />
    </div>
  );
}

VaultGate.propTypes = {
  allowDigitalSignPdfCas: PropTypes.bool.isRequired,
  allowMultipleCasPerRole: PropTypes.bool.isRequired,
  caSettings: PropTypes.object.isRequired,
  gates: PropTypes.object.isRequired,
  role: PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  vault: PropTypes.shape({
    caOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
    id: PropTypes.number.isRequired,
    standardBrokerCa: PropTypes.string.isRequired,
    standardOwnerCa: PropTypes.string.isRequired
  }).isRequired,
  onCaFileUpload: PropTypes.func.isRequired,
  onGatesChange: PropTypes.func.isRequired,
  onSimpleCaSettingsChange: PropTypes.func.isRequired
};

export default VaultGate;
